<div id="wrapper">
    <app-navbar></app-navbar>
  
    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>
  
    <div class="content-page">
      <div class="content">
        <div class="content-pane">
          <div class="container-fluid">
            <div class="breadcrumb">
              <span class="breadcrumb-item">
                <a href="javascript:void(0)">PayEXAP</a>
              </span>
              <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
              <span class="breadcrumb-item" aria-current="page">
                <a routerLink="/purchase-orders">Purchase Orders</a>
              </span>
              <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
              <span class="breadcrumb-item" aria-current="page">
                <a routerLink="/submit-invoice">Submit Invoice</a>
              </span>
            </div>
            <div class="upload-wrapper">
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="pane-header">
                        <h4 class="mt-2">Upload PO Invoice</h4>
                      </div>
                      <form
                        [formGroup]="invoiceData"
                        (ngSubmit)="onInvoiceSubmit()"
                      >
                        <div class="radio-options py-4">
                          <div class="row">
                            <div
                              class="col-3"
                              *ngFor="
                                                              let invType of invoiceTypes
                                                          "
                            >
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  formControlName="invoiceType"
                                  [value]="
                                                                      invType.type
                                                                  "
                                />
                                <label
                                  class="form-check-label"
                                  for="flexRadioDefault1"
                                >
                                  {{ invType.label }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="upload-pane py-5">
                          <div class="row">
                            <div class="col-md-12">
                              <p>Invoice Document</p>
                              <div class="drop-pane">
                                <div class="row">
                                  <div class="col-md-12 text-center">
                                    <div
                                      class="fileupload invoice"
                                      appDragNDrop
                                      (click)="
                                                                              file.click()
                                                                          "
                                      (fileDropped)="
                                                                              selectInvoice(
                                                                                  $event
                                                                              )
                                                                          "
                                    >
                                      <span class="icon-wrapper"
                                        ><i class="ri-file-text-line"></i
                                      ></span>
                                      <span class="ddinfo"
                                        >Drag and Drop File Here</span
                                      >
                                      <p class="ddsperator mt-3">OR</p>
                                      <label
                                        for="file-upload"
                                        class="custom-file-upload"
                                      >
                                        <i class="ri-upload-cloud-2-line"></i>
                                        Choose File to Upload
                                      </label>
                                      <input
                                        type="file"
                                        formControlName="file"
                                        #file
                                        (change)="
                                                                                  selectInvoice(
                                                                                      $any(
                                                                                          $event
                                                                                      )
                                                                                          .target
                                                                                          .files
                                                                                  )
                                                                              "
                                      />
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      *ngIf="
                                                                              fileTypeError
                                                                          "
                                      class="alert alert-danger session-text text-center"
                                      role="alert"
                                    >
                                      <span
                                        >The file type is invalid. File must be a
                                        pdf</span
                                      >
                                    </div>
                                    <div
                                      *ngIf="
                                                                              fileSizeError
                                                                          "
                                      class="alert alert-danger session-text text-center"
                                      role="alert"
                                    >
                                      <span
                                        >The file size is not supported. File must
                                        not exceed {{ Config.maxFileSizeLabel }}.
                                      </span>
                                    </div>
  
                                    <div
                                      class="file-pane"
                                      *ngIf="
                                                                              fileName !==
                                                                              ''
                                                                          "
                                    >
                                      <span> {{ fileName }} </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="upload float-end">
                          <button
                            [disabled]="
                                                          invoiceData.invalid
                                                      "
                            type="submit"
                            class="btn btn-invoice"
                          >
                            Proceed
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="loader-wrapper" *ngIf="loading">
              <div class="loader-content loading" *ngIf="validateEinvoice">
                <div class="loader-pane-processing my-4">
                  <h1 class="mb-3">{{ eLoaderMsg }}</h1>
                  <div class="processing">
                    <div class="rectangle_1"></div>
                    <div class="rectangle_2"></div>
                    <div class="rectangle_3"></div>
                    <div class="rectangle_4"></div>
                    <div class="rectangle_5"></div>
                    <div class="rectangle_6"></div>
                    <div class="rectangle_7"></div>
                    <div class="rectangle_8"></div>
                    <div class="rectangle_9"></div>
                    <div class="rectangle_10"></div>
                    <div class="rectangle_11"></div>
                    <div class="rectangle_12"></div>
                    <div class="rectangle_13"></div>
                    <div class="rectangle_14"></div>
                    <div class="rectangle_15"></div>
                    <div class="rectangle_16"></div>
                    <div class="rectangle_17"></div>
                    <div class="rectangle_18"></div>
                    <div class="rectangle_19"></div>
                    <div class="rectangle_20"></div>
                  </div>
                  <p class="my-2">Please wait a few minutes</p>
                </div>
              </div>
  
              <div
                class="loader-content loading"
                *ngIf="validateEinvoiceResubmit"
              >
                <div class="loader-pane-processing my-4">
                  <h2 class="mb-3">{{ eLoaderMsgResubmit }}</h2>
                  <div class="processing">
                    <div class="rectangle_1"></div>
                    <div class="rectangle_2"></div>
                    <div class="rectangle_3"></div>
                    <div class="rectangle_4"></div>
                    <div class="rectangle_5"></div>
                    <div class="rectangle_6"></div>
                    <div class="rectangle_7"></div>
                    <div class="rectangle_8"></div>
                    <div class="rectangle_9"></div>
                    <div class="rectangle_10"></div>
                    <div class="rectangle_11"></div>
                    <div class="rectangle_12"></div>
                    <div class="rectangle_13"></div>
                    <div class="rectangle_14"></div>
                    <div class="rectangle_15"></div>
                    <div class="rectangle_16"></div>
                    <div class="rectangle_17"></div>
                    <div class="rectangle_18"></div>
                    <div class="rectangle_19"></div>
                    <div class="rectangle_20"></div>
                  </div>
                  <p class="my-2">Please wait a few minutes</p>
                </div>
              </div>
  
              <ng-container *ngIf="!formSubmitted">
                <div class="loader-content loading">
                  <div class="my-3 user-prompt">
                    <h1>Confirm</h1>
                    <h4>Are you sure you want to exit?</h4>
                    <div class="loader-text">
                      <p>You will have to start invoice submission again.</p>
                    </div>
                    <div class="loader-cta my-3">
                      <button class="btn btn-success" (click)="exitForm()">
                        Exit
                      </button>
                      <button class="btn" (click)="cancelExit()">Cancel</button>
                    </div>
                  </div>
                </div>
              </ng-container>
  
              <div class="loader-content error" *ngIf="qrCodeError">
                <div class="loader-text">
                  <i class="ri-error-warning-fill"></i
                  ><span class="ml-2">An Error Occured</span>
                  <p class="text-white my-4">{{ message }}</p>
                </div>
                <div class="loader-cta my-4">
                  <button class="btn btn-error" (click)="closeFileErrorDialog()">
                    Resubmit Invoice
                  </button>
                </div>
              </div>
  
              <div class="loader-content error" *ngIf="signatureError">
                <div class="loader-text">
                  <i class="ri-error-warning-fill"></i
                  ><span class="ml-2">An Error Occured</span>
                  <p class="text-white my-4">{{ message }}</p>
                </div>
                <div class="loader-cta my-4">
                  <button
                    class="btn btn-error"
                    (click)="closeSignatureErrorDialog()"
                  >
                    Resubmit Invoice
                  </button>
                </div>
              </div>
  
              <div class="loader-content loading" *ngIf="validateSignature">
                <div class="loader-pane-processing my-4">
                  <h1 class="mb-3">{{ dsLoaderMsg }}</h1>
                  <div class="processing">
                    <div class="rectangle_1"></div>
                    <div class="rectangle_2"></div>
                    <div class="rectangle_3"></div>
                    <div class="rectangle_4"></div>
                    <div class="rectangle_5"></div>
                    <div class="rectangle_6"></div>
                    <div class="rectangle_7"></div>
                    <div class="rectangle_8"></div>
                    <div class="rectangle_9"></div>
                    <div class="rectangle_10"></div>
                    <div class="rectangle_11"></div>
                    <div class="rectangle_12"></div>
                    <div class="rectangle_13"></div>
                    <div class="rectangle_14"></div>
                    <div class="rectangle_15"></div>
                    <div class="rectangle_16"></div>
                    <div class="rectangle_17"></div>
                    <div class="rectangle_18"></div>
                    <div class="rectangle_19"></div>
                    <div class="rectangle_20"></div>
                  </div>
                  <p class="my-2">Please wait a few minutes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
<ng-template #sizeErrorModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">File Size Error</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>The selected file exceeds the allowed size limit. Please upload a smaller file.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.dismiss()">OK</button>
  </div>
</ng-template>